export default __webpack_public_path__ + "static/media/hero.b47d0ad9.jpg";